const validationAlertWidth = 50,
  smartDocsWidth = 400,
  smartDataWidth = 400

const nodeConfig = [
  { type: 'smartDocs', width: smartDocsWidth + validationAlertWidth, height: 320 },
  { type: 'smartData', width: smartDataWidth + validationAlertWidth, height: 182 }
]

const getNodeConfig = (type) => {
  return nodeConfig.find((node) => node.type === type)
}

const taskSchema = {
  id: null,
  isRunning: true,
  name: '',
  response: null,
  config: null
}

const workflowSchema = {
  title: '',
  description: '',
  totalTasks: '',
  lastRun: '',
  incompleteEntry: false,
  profile: []
  //profile structure as below
  // {
  //   content: 'AH'
  // },
  // {
  //   img: `${imgPath}/avatar-s-7.jpg`
  // }
}

const workflowSkeletonCount = Array.from(Array(10).keys())

export {
  nodeConfig,
  getNodeConfig,
  validationAlertWidth,
  smartDocsWidth,
  smartDataWidth,
  taskSchema,
  workflowSchema,
  workflowSkeletonCount
}
